module.exports = __webpack_public_path__ + "resources/img/certi_iso_iec_29100.ba6ad68a06f95c4f564f651bb46e011c.png";